import scrollToItem from "./helpers/scrollToItem.js";

const solutions = () => {
	if (!document.querySelector("#solutions")) return;
	scrollToItem();
};

solutions();

/**
 * Добавляем отступ от верха
 */
if (document.querySelector(".solutions__nav")) {
	window.addEventListener("scroll", () => {
		if (document.querySelector(".solutions__nav").style.top === `${document.querySelector("header").clientHeight}px`) return;

		document.querySelector(".solutions__nav").style.top = `${document.querySelector("header").clientHeight}px`;
	});
}
